import { licenseServiceHttpClient } from "src/common/LicenseServiceHttpClient";
import { LicenseListData } from "src/models/license";
export class LicenseManageSeviceClient {
  async signLicense(data: LicenseListData) {
    return await licenseServiceHttpClient.post(
      "/api/LicenseAdmin/SignLicense",
      data,
      {}
    );
  }

  async licenseList(
    pageIndex?: number,
    pageSize?: number,
    licensedToCompanyName?: string,
    contractId?: string,
    application?: number,
    expireOptions?: number,
    licenseType?: string
  ) {
    return await licenseServiceHttpClient.post(
      "/api/LicenseAdmin/GetLicenseList",
      {
        pageIndex,
        pageSize,
        licensedToCompanyName,
        application,
        expireOptions,
        contractId,
        licenseType,
      },
      {}
    );
  }

  async licenseDetail(id: number) {
    return await licenseServiceHttpClient.get(`/api/LicenseAdmin/${id}`, {});
  }

  async userRole() {
    return await licenseServiceHttpClient.get("/api/UserAuthorities", {});
  }

  async exportLicenseList(
    licensedToCompanyName?: string,
    contractId?: string,
    application?: number,
    expireOptions?: number,
    licenseType?: string
  ) {
    return await licenseServiceHttpClient.get(
      "/api/LicenseAdmin/Export",

      {
        params: {
          licensedToCompanyName,
          application,
          expireOptions,
          contractId,
          licenseType,
        },
        responseType: "blob",
      }
    );
  }
}
export const LicenseSeviceClient = new LicenseManageSeviceClient();
